export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M23 4v12H5V4zm-6 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M7 8v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V8a2 2 0 0 1-2-2H9a2 2 0 0 1-2 2M1 8h2v10h16v2H1z\"/>"
};